<template>
<v-card flat >
  <v-card-title class='overline pb-0' >
    <v-btn v-if='withClose' @click='$emit("close")' icon small ><v-icon small >close</v-icon></v-btn>
    <v-spacer></v-spacer>
    {{dateRangeString}}
    <v-spacer></v-spacer>
    <v-menu nudge-bottom >
      <template v-slot:activator="{ on }">
      <v-btn v-on='on' slot='activator' small icon >
        <v-icon>arrow_drop_down</v-icon>
      </v-btn>
      </template>
      <v-list dense>
        <v-list-tile
          v-for='action in actions' :key=action.id
          @click='action.onclick' >
          <v-list-tile-content>
            <v-list-tile-title>{{action.title}}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
  </v-menu>
  </v-card-title>
    <v-list dense v-if='showFilters' >
      <v-list-tile v-for='filter in filters' :key='filter'>
        <v-list-tile-content>
          <v-list-tile-title>
            {{filter}}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-date-picker flat full-width no-title no-messages
      v-model="selectedDate"
      :pickerDate='pickerDate'
      :multiple='calendarType === "date"'
      :type='calendarType'
      class='elevation-0 mb-0 pb-0' >
    </v-date-picker>
  <v-card-actions class='mt-0' >
    <template v-if='withMonthPicker' >
      <v-btn small outline outlined
        v-if='calendarType=="date"'
        @click='setMonthPicker'
        flat >Month picker</v-btn >
      <v-btn small outline outlined
        v-else
        @click="setDatePicker" flat >Date picker</v-btn >
    </template>
    <v-spacer></v-spacer>
    <v-btn v-if='withOk' @click='ok' small outline outlined color='primary' >OK</v-btn>
  </v-card-actions>
</v-card>
</template>

<script>
import moment from 'moment'

export default {
  moment,
  name: 'DateRangePicker',
  props: {
    value: { type: Object },
    initialFromDate: { type: String },
    initialToDate: { type: String },
    withClose: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: false },
    withMonthPicker: { type: Boolean, default: true },
    withOk: { type: Boolean, default: true },
    closeOnDone: { type: Boolean, default: true },
    title: { type: String, default: 'Choose a date range' },
    touch: { type: Number, default: 0 },
    clearTouch: { type: Number, default: 0 }
  },
  data () {
    return {
      showFilters: false,
      fromDate: null,
      toDate: null,
      activeField: 'fromDate',
      pickerDate: null,
      selectedDate: [],
      calendarType: 'date',
      filters: [
        'This week',
        'Last week',
        'This month',
        'Last month',
        'Last 7 days',
        'Last 14 days',
        'Last 31 days'
      ]
    }
  },
  mounted () {
    if (this.value) {
      if (this.value.from) { this.fromDate = this.value.from }
      if (this.value.to) { this.toDate = this.value.to }
    }
  },
  computed: {
    dateRangeString () {
      // if (this.calendarType === 'month') {
      //   return moment(this.fromDate).format('MMMM')
      // }
      // if (this.calendarType === 'date') {
      let str = 'No date selected'
      if (this.fromDate) {
        str = `from ${this.fromDate}`
      }
      if (this.toDate) {
        let fromMoment = moment(this.fromDate)
        let toMoment = moment(this.toDate)
        let isSameMonth = fromMoment.month() === toMoment.month()
        console.log(fromMoment.month(), toMoment.month())
        if (isSameMonth) {
          str = `${fromMoment.format('ddd D')} to ${toMoment.format('ddd D')} ${fromMoment.format('MMM')}`
        } else {
          str = `from ${fromMoment.format('ddd D MMM')} to ${this.dateformat(this.toDate)}`
        }
        let dayCount = moment.duration(toMoment.diff(fromMoment)).as('days') + 1
        str += ' (' + dayCount + ' days)'
      }
      return str
      // }
    },
    range () {
      return {
        from: this.fromDate,
        to: this.toDate
      }
    },
    actions () {
      return [
        {
          id: 'clear',
          title: 'Clear',
          icon: 'close',
          onclick: this.reset
        },
        {
          id: 'this-month',
          title: 'This month',
          icon: 'calendar_today',
          onclick: this.setMonth
        }
      ]
    }
  },
  methods: {
    reset () {
      this.toDate = null
      this.fromDate = null
      this.activeField = 'fromDate'
    },
    ok () {
      this.$emit('input', this.range)
      this.$emit('close')
    },
    setMonthPicker () {
      if (Array.isArray(this.selectedDate)) {
        if (this.selectedDate.length === 0) {
          this.selectedDate = null
        } else {
          this.selectedDate = moment(this.selectedDate[0]).format('YYYY-MM')
        }
      }
      this.calendarType = 'month'
    },
    setDatePicker () {
      this.selectedDate = []
      if (this.fromDate) {
        this.selectedDate.push(this.fromDate)
        this.pickerDate = moment(this.fromDate).format('YYYY-MM')
      }
      if (this.toDate) {
        this.selectedDate.push(this.toDate)
      }
      if (!this.pickerDate) {
        this.pickerDate = moment().format('YYYY-MM')
      }
      let vm = this
      window.setTimeout(() => { vm.pickerDate = null }, 100)
      this.calendarType = 'date'
    },
    setMonth (selectedDate) {
      if (!selectedDate) {
        selectedDate = moment().format('YYYY-MM')
      }
      let startDate = selectedDate + '-01'
      let endDate = moment(startDate)
        .endOf('month')
        .format('YYYY-MM-DD')
      this.fromDate = startDate
      this.toDate = endDate
    },
    setDateRange (selectedDate) {
      if (!this.selectedDate || this.selectedDate.length === 0) {
        return
      }
      if (selectedDate.length === 1) {
        this.fromDate = selectedDate
        return
      }
      if (this.selectedDate.length > 2) {
        this.selectedDate = this.selectedDate.slice(1)
      }
      this.fromDate = moment.min(
        moment(this.selectedDate[0]),
        moment(this.selectedDate[1])
      ).format('YYYY-MM-DD')
      this.toDate = moment.max(
        moment(this.selectedDate[0]),
        moment(this.selectedDate[1])
      ).format('YYYY-MM-DD')
    }
  },
  watch: {
    selectedDate () {
      if (this.selectedDate) {
        if (this.calendarType === 'month') {
          this.setMonth(this.selectedDate)
        }
        if (this.calendarType === 'date') {
          this.setDateRange(this.selectedDate)
        }
      }
    },
    clearTouch () {
      this.reset()
    },
    range () {
      if (!this.withOk) {
        this.$emit('input', this.range)
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// DateRangePicker.vue?419439f0